import { AutocompleteInput } from "react-admin";
import * as React from "react";
import PropTypes from "prop-types";

const QuarantineInput = ({ form, quarantinedata }) => {
  React.useEffect(() => {
    if (form.getFieldState("refNo")?.value !== undefined) {
      if (form.getFieldState("refNo")?.value !== "") {
        var filtered_data = quarantinedata.filter(t => {
          return t.refNo == form.getFieldState("refNo")?.value;
        });
        form.change("customerName", filtered_data?.[0]?.customerName);
        form.change("customerPo", filtered_data?.[0]?.customerPo);
        form.change("pn", filtered_data?.[0]?.pn);
        form.change("sn", filtered_data?.[0]?.sn);
        form.change("awbNo", filtered_data?.[0]?.awb);
      }
    }
  }, [form.getFieldState("refNo")?.value, quarantinedata]);

  return (
    <AutocompleteInput
      source="refNo"
      optionText="id"
      optionValue="id"
      choices={quarantinedata}
      variant="outlined"
      fullWidth
    />
  );
};

QuarantineInput.propTypes = {
  form: PropTypes.any,
};

export default QuarantineInput;
